/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import FlashCardsArray from './components/FlashCardsArray';
import EmentorArray from '../shared/EmentorArray';

const TerminologyReview = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Flash Cards" instructions='Use the "Add Card" button below to add an instance of a Flash Card.' required />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => <FlashCardsArray inputDir={inputDir} {...{ control, errors }} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />

      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default TerminologyReview;